import { ConfettiEffect } from './ConfettiEffect';
import { NeuralIcon } from './agent/NeuralIcon';

interface UpgradeModalProps {
  onDismiss: () => void;
  trial?: boolean;
  trialEndDate?: string;
}

export function UpgradeModal({ onDismiss, trial, trialEndDate }: UpgradeModalProps) {
  return (
    <div className="upgrade-modal-overlay" onClick={onDismiss}>
      <ConfettiEffect />
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <NeuralIcon size={48} />
        <h2 className="upgrade-modal-title">Welcome to Pro</h2>
        <p className="upgrade-modal-subtitle">
          {trial
            ? 'You have 30 days of full Pro access \u2014 no credit card needed. Explore everything.'
            : 'Unlimited ideas. Semantic search. Claude MCP. CLI. Mind maps. Everything unlocked.'}
        </p>

        <div className="upgrade-modal-features">
          <ul className="plan-features">
            <li><span className="plan-check">&#10003;</span> Semantic search &amp; duplicate detection</li>
            <li><span className="plan-check">&#10003;</span> Claude MCP connector &amp; Code skill</li>
            <li><span className="plan-check">&#10003;</span> nrepo CLI &mdash; <code>npm i -g @neuralconfig/nrepo</code></li>
            <li><span className="plan-check">&#10003;</span> Mind map, Siri, email</li>
            <li><span className="plan-check">&#10003;</span> Unlimited ideas &mdash; no cap</li>
          </ul>
        </div>

        <button className="btn btn-primary plan-cta" onClick={onDismiss}>
          Let's go
        </button>

        {trial && (
          <p className="upgrade-modal-trial-note">
            Your trial ends {trialEndDate ?? 'in 30 days'}. You can upgrade anytime at{' '}
            <a href="/upgrade">/upgrade</a>.
          </p>
        )}
      </div>
    </div>
  );
}
